// extracted by mini-css-extract-plugin
export default {"award":"Award_award__Mau2h","open":"Award_open__wFcLA","content":"Award_content__Fg80Z","heading":"Award_heading__GMwiq","emoji":"Award_emoji__wK6Dp"};